export const FALLBACK_URL = 'https://www.topdanmark.dk/faa-hjaelp/kontakt-os/#skriv-til-os';
export const RECEIPT_PATH = 'kvittering';
